/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { downloadProgressControllerGenerateSessionId } from '../fn/download-progress/download-progress-controller-generate-session-id';
import { DownloadProgressControllerGenerateSessionId$Params } from '../fn/download-progress/download-progress-controller-generate-session-id';
import { downloadProgressControllerSse } from '../fn/download-progress/download-progress-controller-sse';
import { DownloadProgressControllerSse$Params } from '../fn/download-progress/download-progress-controller-sse';

@Injectable({ providedIn: 'root' })
export class DownloadProgressService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `downloadProgressControllerGenerateSessionId()` */
  static readonly DownloadProgressControllerGenerateSessionIdPath = '/api/download-progress/sessionId';

  /**
   * 세션 ID 생성.
   *
   * PDF 생성 진행상황을 위한 세션 ID를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadProgressControllerGenerateSessionId()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProgressControllerGenerateSessionId$Response(params?: DownloadProgressControllerGenerateSessionId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return downloadProgressControllerGenerateSessionId(this.http, this.rootUrl, params, context);
  }

  /**
   * 세션 ID 생성.
   *
   * PDF 생성 진행상황을 위한 세션 ID를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadProgressControllerGenerateSessionId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProgressControllerGenerateSessionId(params?: DownloadProgressControllerGenerateSessionId$Params, context?: HttpContext): Observable<void> {
    return this.downloadProgressControllerGenerateSessionId$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `downloadProgressControllerSse()` */
  static readonly DownloadProgressControllerSsePath = '/api/download-progress/{sessionId}';

  /**
   * PDF 생성 진행상황 스트림.
   *
   * SSE를 통해 PDF 생성 진행상황을 실시간으로 제공합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadProgressControllerSse()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProgressControllerSse$Response(params: DownloadProgressControllerSse$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return downloadProgressControllerSse(this.http, this.rootUrl, params, context);
  }

  /**
   * PDF 생성 진행상황 스트림.
   *
   * SSE를 통해 PDF 생성 진행상황을 실시간으로 제공합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadProgressControllerSse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadProgressControllerSse(params: DownloadProgressControllerSse$Params, context?: HttpContext): Observable<void> {
    return this.downloadProgressControllerSse$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
